var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import AnnotationContext from "@cloudscape-design/components/annotation-context";
import { useToolbarTutorialStore } from "../hook/useToolbarTutorialStore";
import { FloatingToolbar } from "./FloatingToolbar";
/**
 * Get current step title based current step index starting from 0.
 */
var getCurrentStepTitle = function (tutorial, step) {
    return tutorial.tasks[0].steps[step].title;
};
/**
 * This is a tutorial annotation context wrapper. It provides state management and i18n strings for tutorial.
 * It can be used directly with FloatingToolbar component, see FloatingToolbarWithTutorial component.
 * Or it can be used with any other component that needs tutorial, make sure the children component has corresponding hotspot id provided in currentTutorial.
 * Remember to put it on top-lvel of the component tree so it won't be re-rendered once there's a state change.
 */
export var TutorialAnnotationContext = function (_a) {
    var props = __rest(_a, []);
    var _b = useToolbarTutorialStore(), showTutorial = _b.showTutorial, currentStep = _b.currentStep, setShowTutorial = _b.setShowTutorial, setTutorialCompleted = _b.setTutorialCompleted, setCurrentStep = _b.setCurrentStep;
    return (_jsx(AnnotationContext
    // This is supposed to be used with TutorialPanel which we don't need here.
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    , __assign({ 
        // This is supposed to be used with TutorialPanel which we don't need here.
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onStartTutorial: function () { }, 
        // This is supposed to be used with TutorialPanel which we don't need here.
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onExitTutorial: function () { }, onFinish: function () {
            setTutorialCompleted(true);
            setShowTutorial(false);
            setCurrentStep(0);
            props.onFinish && props.onFinish();
        }, onStepChange: function (_a) {
            var detail = _a.detail;
            props.onStepChange && props.onStepChange(detail);
            setCurrentStep(detail.step);
        }, currentTutorial: showTutorial ? props.currentTutorial : null, i18nStrings: {
            stepCounterText: props.tutorialI18nStrings.stepCounterText,
            taskTitle: function () {
                return getCurrentStepTitle(props.currentTutorial, currentStep);
            },
            labelHotspot: props.tutorialI18nStrings.labelHotspot,
            nextButtonText: props.tutorialI18nStrings.nextButtonText,
            previousButtonText: props.tutorialI18nStrings.previousButtonText,
            finishButtonText: props.tutorialI18nStrings.finishButtonText,
            labelDismissAnnotation: props.tutorialI18nStrings.labelDismissAnnotation,
        } }, { children: props.children })));
};
/**
 * This component renders a floating toolbar with toolbar tutorial.
 * Make sure hotspot id in currentTutorial matches the hotspot id in FloatingToolbar component (id: hotspot1,...,hotspot4).
 */
export var FloatingToolbarWithTutorial = function (_a) {
    var props = __rest(_a, []);
    return (_jsx(TutorialAnnotationContext, __assign({ currentTutorial: props.currentTutorial, tutorialI18nStrings: props.tutorialI18nStrings, onFinish: props.onFinish, onStepChange: props.onStepChange }, { children: _jsx(FloatingToolbar, { i18nStrings: props.i18nStrings, items: props.items, minimizedView: props.minimizedView, defaultPosition: props.defaultPosition, bounds: props.bounds, floatingNotificationListProps: props.floatingNotificationListProps, withHotspot: true }) })));
};
